export const COMMUNITY_OUTREACH_INQUIRY_FORM = 'INQUIRY_FORM';
export const OUTREACH_LOCATIONS_INQUIRY_FORM = 'ENROLMENT_LOCATIONS';
